import gsap from '../../../gsap-public/esm/index.js';

class Cursor {
  constructor() {
    this.cursor = document.querySelector('[data-cursor]');
    if (!this.cursor) return;

    // Check if device has hover capability (not touch-only)
    if (!window.matchMedia('(hover: hover)').matches) {
      this.cursor.style.display = 'none';
      return;
    }

    this.inner = this.cursor.querySelector('.cursor__inner');
    this.pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    this.mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };

    this.init();
  }

  init() {
    // Hide default cursor on interactive elements
    const hoverElements = document.querySelectorAll('a, button, .portfolio-card, .service-card, input, textarea');

    hoverElements.forEach(el => {
      el.addEventListener('mouseenter', () => this.grow());
      el.addEventListener('mouseleave', () => this.shrink());
    });

    // Track mouse movement
    window.addEventListener('mousemove', (e) => {
      this.mouse.x = e.clientX;
      this.mouse.y = e.clientY;
    });

    // Render loop
    this.render();
  }

  render() {
    // Smooth lerp
    this.pos.x += (this.mouse.x - this.pos.x) * 0.15;
    this.pos.y += (this.mouse.y - this.pos.y) * 0.15;

    gsap.set(this.cursor, {
      x: this.pos.x,
      y: this.pos.y
    });

    requestAnimationFrame(() => this.render());
  }

  grow() {
    gsap.to(this.inner, {
      scale: 2,
      duration: 0.3,
      ease: 'power2.out'
    });
  }

  shrink() {
    gsap.to(this.inner, {
      scale: 1,
      duration: 0.3,
      ease: 'power2.out'
    });
  }
}

export default Cursor;
